export default function Process({ onTalkClick }) {
  const steps = [
    {
      n: '01',
      t: 'Plan the funnel',
      d: 'We learn your offers, goals, and customers, then outline the fastest way to get leads.',
    },
    {
      n: '02',
      t: 'Launch in 14 days',
      d: 'We ship the new site pages, ads, and emails so we can watch real leads come in quickly.',
    },
    {
      n: '03',
      t: 'Tweak every week',
      d: 'We compare numbers, share a short Loom update, and double down on what’s closing sales.',
    },
  ];

  return (
    <section id="process" className="bg-slate-50 py-20">
      <div className="mx-auto max-w-6xl px-6">
        <p className="text-sm uppercase tracking-[0.2em] text-slate-500">How we partner</p>
        <h2 className="mt-2 text-3xl font-semibold text-slate-900 md:text-4xl">A funnel built like a sprint</h2>
        <p className="mt-4 max-w-3xl text-slate-600">Three moves repeat every month to keep deals flowing.</p>

        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {steps.map((step) => (
            <div key={step.n} className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm">
              <span className="text-xs font-medium uppercase tracking-[0.3em] text-slate-400">{step.n}</span>
              <h3 className="mt-3 text-xl font-semibold text-slate-900">{step.t}</h3>
              <p className="mt-3 text-sm text-slate-600">{step.d}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 rounded-3xl border border-blue-100 bg-white/70 p-8 shadow-sm backdrop-blur md:flex-row md:items-center">
          <div>
            <h3 className="text-xl font-semibold text-slate-900">Ready to map your first sprint?</h3>
            <p className="mt-2 text-sm text-slate-600">Leave with a 30-day launch list, media plan, and KPIs.</p>
          </div>
          <button
            type="button"
            onClick={() => onTalkClick?.()}
            className="inline-flex items-center justify-center rounded-full bg-slate-900 px-6 py-3 text-sm font-semibold text-white shadow hover:opacity-90"
          >
            Plan my first sprint →
          </button>
        </div>
      </div>
    </section>
  );
}
